import script from "./NotRecommendedDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotRecommendedDialog.vue?vue&type=script&lang=ts&setup=true"

import "./NotRecommendedDialog.vue?vue&type=style&index=0&id=da88c5ae&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da88c5ae"]])

export default __exports__